import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Table, Spinner, Alert, Container, Button, Modal } from 'react-bootstrap';
import AdminSidebar from "../components/AdminSidebar";
import AdminNavbar from '../components/AdminNavbar';
import { useSidebar } from '../components/SidebarContext'; // 👈 Import context

function StudentsList() {
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const { isSidebarOpen } = useSidebar(); // 👈 Use sidebar context
  const sidebarWidth = isSidebarOpen ? '15.6rem' : '4.4rem'; // 👈 Dynamic sidebar width

  const fetchAllStudents = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await axios.get('https://devexam.doode.in/api/student/studentlist', {
        withCredentials: true
      });

      console.log("API Response:", response.data);

      if (!Array.isArray(response.data)) {
        throw new Error("Expected array of students but got different data structure");
      }

      const formattedStudents = response.data.map(student => ({
        id: student._id,
        username: student.username,
        fullName: student.fullName,
        email: student.email,
        createdAt: new Date(student.createdAt),
      }));

      setStudents(formattedStudents);
    } catch (error) {
      console.error('Error fetching students:', error);
      let errorMessage = "Failed to load students";

      if (error.response) {
        if (error.response.status === 401) {
          errorMessage = "Unauthorized - Please login as admin";
        } else if (error.response.data?.message) {
          errorMessage = error.response.data.message;
        } else {
          errorMessage = `Server error: ${error.response.status}`;
        }
      } else if (error.message) {
        errorMessage = error.message;
      }

      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllStudents();
  }, []);

  const handleViewStudent = (student) => {
    setSelectedStudent(student);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedStudent(null);
  };

  if (loading) {
    return (
      <div style={{ display: 'flex', height: '100vh' }}>
        <AdminNavbar />
        <AdminSidebar />
        <Container className="mt-5 text-center">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
          <p className="mt-2">Loading student data...</p>
        </Container>
      </div>
    );
  }

  return (
    <div style={{
      display: 'flex',
      height: '100vh',
      overflow: 'hidden',
      fontFamily: 'Arial, sans-serif'
    }}>
      <AdminNavbar />
      <div>
        <AdminSidebar />
      </div>

      <div style={{
        flex: 1,
        overflowY: 'auto',
        padding: '20px',
        backgroundColor: '#f8f9fa',
        marginLeft: sidebarWidth, // 👈 Use dynamic sidebar width
        marginTop: '60px'
      }}>
        <Container style={{
          backgroundColor: 'white',
          borderRadius: '8px',
          boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
          padding: '25px'
        }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '25px'
          }}>
            <h2 style={{
              fontSize: '24px',
              fontWeight: '600',
              color: '#2c3e50',
              margin: 0
            }}>
              Registered Students
            </h2>

            <Button
              variant="primary"
              onClick={fetchAllStudents}
              style={{
                backgroundColor: '#3498db',
                border: 'none',
                borderRadius: '6px',
                padding: '8px 16px',
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <span style={{ marginRight: '8px' }}>↻</span> Refresh
            </Button>
          </div>

          {error ? (
            <Alert variant="danger" style={{ borderRadius: '6px' }}>
              <Alert.Heading style={{ fontSize: '18px' }}>Error Loading Students</Alert.Heading>
              <p>{error}</p>
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginTop: '15px'
              }}>
                <div>
                  <p style={{ fontWeight: '500', marginBottom: '5px' }}>Troubleshooting steps:</p>
                  <ul style={{ marginBottom: 0 }}>
                    <li>Ensure you're logged in as admin</li>
                    <li>Check your internet connection</li>
                    <li>Verify the API endpoint is correct</li>
                  </ul>
                </div>
                <Button
                  variant="outline-danger"
                  onClick={fetchAllStudents}
                  style={{
                    borderWidth: '2px',
                    fontWeight: '500'
                  }}
                >
                  Retry
                </Button>
              </div>
            </Alert>
          ) : (
            <div className="table-responsive">
              <Table striped bordered hover style={{
                borderRadius: '8px',
                overflow: 'hidden',
                marginBottom: 0
              }}>
                <thead style={{ backgroundColor: '#2c3e50', color: 'white' }}>
                  <tr>
                    <th style={{ padding: '15px', fontWeight: '600' }}>#</th>
                    <th style={{ padding: '15px', fontWeight: '600' }}>Username</th>
                    <th style={{ padding: '15px', fontWeight: '600' }}>Full Name</th>
                    <th style={{ padding: '15px', fontWeight: '600' }}>Email</th>
                    <th style={{ padding: '15px', fontWeight: '600' }}>Registration Date</th>
                    <th style={{ padding: '15px', fontWeight: '600', textAlign: 'center' }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {students.length === 0 ? (
                    <tr>
                      <td colSpan="6" style={{
                        padding: '30px',
                        textAlign: 'center',
                        color: '#6c757d',
                        fontStyle: 'italic'
                      }}>
                        No students registered yet
                      </td>
                    </tr>
                  ) : (
                    students.map((student, index) => (
                      <tr key={student.id}>
                        <td style={{ padding: '15px', verticalAlign: 'middle' }}>{index + 1}</td>
                        <td style={{ padding: '15px', verticalAlign: 'middle', fontWeight: '500' }}>
                          {student.username}
                        </td>
                        <td style={{ padding: '15px', verticalAlign: 'middle' }}>{student.fullName}</td>
                        <td style={{ padding: '15px', verticalAlign: 'middle' }}>{student.email}</td>
                        <td style={{ padding: '15px', verticalAlign: 'middle' }}>
                          {student.createdAt.toLocaleDateString('en-US', {
                            year: 'numeric',
                            month: 'short',
                            day: 'numeric'
                          })}
                        </td>
                        <td style={{ padding: '15px', textAlign: 'center', verticalAlign: 'middle' }}>
                          <Button
                            variant="info"
                            size="sm"
                            onClick={() => handleViewStudent(student)}
                            style={{
                              minWidth: '80px',
                              fontWeight: '500',
                              border: 'none',
                              boxShadow: '0 2px 5px rgba(0,0,0,0.1)'
                            }}
                          >
                            View
                          </Button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
            </div>
          )}
        </Container>
      </div>

      {/* Student Details Modal */}
      <Modal
        show={showModal}
        onHide={handleCloseModal}
        centered
        backdrop="static"
      >
        <Modal.Header closeButton style={{
          backgroundColor: '#f8f9fa',
          borderBottom: '1px solid #dee2e6'
        }}>
          <Modal.Title style={{
            fontSize: '20px',
            fontWeight: '600',
            color: '#2c3e50'
          }}>
            Student Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: '25px' }}>
          {selectedStudent && (
            <div style={{ lineHeight: '2' }}>
              <p style={{ marginBottom: '15px' }}>
                <strong style={{ display: 'inline-block', width: '120px' }}>Username:</strong>
                <span style={{ fontWeight: '500' }}>{selectedStudent.username}</span>
              </p>
              <p style={{ marginBottom: '15px' }}>
                <strong style={{ display: 'inline-block', width: '120px' }}>Full Name:</strong>
                <span style={{ fontWeight: '500' }}>{selectedStudent.fullName}</span>
              </p>
              <p style={{ marginBottom: '15px' }}>
                <strong style={{ display: 'inline-block', width: '120px' }}>Email:</strong>
                <span style={{ fontWeight: '500' }}>{selectedStudent.email}</span>
              </p>
              <p>
                <strong style={{ display: 'inline-block', width: '120px' }}>Registered:</strong>
                <span style={{ fontWeight: '500' }}>
                  {selectedStudent.createdAt.toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                  })}
                </span>
              </p>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer style={{
          backgroundColor: '#f8f9fa',
          borderTop: '1px solid #dee2e6'
        }}>
          <Button
            variant="secondary"
            onClick={handleCloseModal}
            style={{
              padding: '8px 20px',
              fontWeight: '500',
              borderRadius: '6px'
            }}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default StudentsList;
